{MnemoREM
****************************************************************************************************
**                                                                                                **
    Copyright:          (c) MFC Worx
    Address:            Wiefelstederstr. 4a, 26160 Bad Zwischenahn, Germany
    Mobile:             +49 151 12 16 41 43
    Mailto:             michael.ellermann@mfc-worx.com
    HTTP:               mfc-worx.com

    UnitName:           PrjFormMain
    Folder:             ../..
    Created:            Sun 07.05.2023 21:45
    Author:             Michael Ellermann
                        Karl-Heinz Warnkoenig

    ShortDescription:

    Description:

**                                                                                                **
****************************************************************************************************
MnemoREM}

unit PrjFormMain;

interface

uses
  System.SysUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  Vcl.Menus,
  WEBLib.Menus,
  WEBLib.REST,
  WEBLib.Buttons,
  Vcl.Controls,
  WEBLib.ExtCtrls,
  Vcl.Graphics,
  Vcl.StdCtrls,
  WEBLib.StdCtrls,
  Vcl.Imaging.GIFImg,
  Vcl.Imaging.jpeg,

  HBMWebData,
  PrjClassHBMDataAccess,
  PrjClassTokenInformation,
  WEBLib.Actions,
  WEBLib.Lang,

  Vcl.Imaging.pngimage,
  PrjFormDefault,

  XData.Web.Connection,
  XData.Web.Client,
  Data.DB,
  XData.Web.JsonDataset,
  XData.Web.Dataset, WEBLib.Storage;

type
  TPeriodCaculationType = (ctpNone, ctpNextPeriod, ctpActualPeriod);

  TPrjFormsMain = class(TPrjFormsDefault)
    XDataWebConnectionMain: TXDataWebConnection;
    pnNavBar: TPanel;
    btnLogout: TButton;
    pnSimulation: TPanel;
    pnEntscheidungsdaten: TPanel;
    pnBerechnung: TPanel;
    pnBerichte: TPanel;
    WebLabel5: TLabel;
    WebLabel2: TLabel;
    WebLabel3: TLabel;
    btnResetSimulation: TButton;
    btnRestePassword: TButton;
    WebLabel4: TLabel;
    btnSeminarKennDaten: TButton;
    btnAusgangsLoesung: TButton;
    btnPeriodenUnabhaengigeDaten: TButton;
    btnWirkungskurven: TButton;
    WebLabel6: TLabel;
    WebLabel7: TLabel;
    WebLabel8: TLabel;
    WebLabel9: TLabel;
    btnQuickZweckMittel: TButton;
    btnQuickMVZ: TButton;
    btnEntscheidungsdaten: TButton;
    btnPeriodenAbhaengigeDaten: TButton;
    WebLabel10: TLabel;
    WebLabel11: TLabel;
    WebLabel12: TLabel;
    btnCalculateActPeriod: TButton;
    btnCalculateNextPeriod: TButton;
    WebLabel13: TLabel;
    WebLabel14: TLabel;
    WebLabel15: TLabel;
    btnTLNReportPrint: TButton;
    btnSPLReportPrint: TButton;
    WebMessageDlg: TMessageDlg;
    XDataWebDataSetModul: TXDataWebDataSet;
    procedure btnAusgangsLoesungClick(Sender: TObject);
    procedure btnCalculateActPeriodClick(Sender: TObject);
    procedure btnCalculateNextPeriodClick(Sender: TObject);
    procedure btnEntscheidungsdatenClick(Sender: TObject);
    procedure btnLogoutClick(Sender: TObject);
    procedure btnPeriodenAbhaengigeDatenClick(Sender: TObject);
    procedure btnPeriodenUnabhaengigeDatenClick(Sender: TObject);
    procedure btnQuickMVZClick(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
    procedure btnRestePasswordClick(Sender: TObject);
    procedure btnQuickZweckMittelClick(Sender: TObject);
    procedure btnResetSimulationClick(Sender: TObject);
    procedure btnSeminarKennDatenClick(Sender: TObject);
    procedure btnSPLReportPrintClick(Sender: TObject);
    procedure btnTLNReportPrintClick(Sender: TObject);
    procedure btnWirkungskurvenClick(Sender: TObject);
    procedure XDataWebConnectionMainConnect(Sender: TObject);
    procedure XDataWebConnectionMainError(Error: TXDataWebConnectionError);
    procedure XDataWebDataSetModulAfterOpen(DataSet: TDataSet);
    procedure WebFormDestroy(Sender: TObject);
  strict private
    [Async]
    function CalculateNextPeriod: Boolean; async;
    [Async]
    procedure PerformInitialRun(AMessage: string = ''); async;
    [Async]
    procedure PerformReInitialRun; async; virtual;
    [Async]
    function ShowLogOnDialog(AMessage: string = ''): Boolean; async; virtual;
  private
    FApplicationType: TApplicationTyp;
    FLoggedOn: Boolean;
    FPeriodCalculationType : TPeriodCaculationType;
    function GetLoggedOn: Boolean;
    [Async]
    function GetNewToken: Boolean; async;

    [Async]
    function PreCheckCalculatePeriod: Boolean; async;
    { Private-Deklarationen }
  protected
    procedure SetMenuEnable(Value: boolean = false); override;
  public
    FLocalStorage : TLocalStorage;
    procedure ToggleGUI; virtual;
    [Async]
    function CalculatePeriods: Boolean; async;
    [Async]
    function ResetPaswwords: Boolean; async;
    [Async]
    function ResetSimulation: boolean; async;


    { Public-Deklarationen }
  published
    property LoggedOn: Boolean read GetLoggedOn;
    property ApplicationType: TApplicationTyp read FApplicationType write FApplicationType default atNone;
  protected procedure LoadDFMValues; override; end;

const
  cResetPasswords   = 'Sollen die Passwörter aller Teilnehmer wirklich zurück gesetzt werden ?';
  cResetSimulations = 'Soll die Simulation wirklich zurück gesetzt werden ?';
  cResetSimLogOutWarning = 'Haben alle anderen Teilnehmer die Simulation verlassen ?';

var
  PrjFormsMain: TPrjFormsMain;

{$DEFINE APPISSPL}
{$DEFINE APPISADMIN}


const
   cCalculateNextPeriodOKMsg = 'Die Berechnung des nächsten Geschäftsjahres war erfolgreich';
   cCalculateActPeriodOKMsg  = 'Die Berechnung des aktuellen Geschäftsjahres war erfolgreich';
   cCalculatePeriodNotOkMsg  = 'Die Berechnung des neuen Geschäftsjahres war nicht erfolgreich';
   cResetSimuNotOkMsg        = 'Das zurück setzen der Simulation war nicht erfolgreich';
   cResetSimuOkMsg           = 'Das zurück setzen der Simulation war erfolgreich';
   cResetSimuCalcActPeriodMsg  = 'Sie müssen nun die Periode [0] neu berechnen, und dann die nächste Periode [1] berechnen ';


implementation

{$R *.dfm}

uses
  WEBLib.WebTools,
  HBMWebDef,

  wxBaseClassWebTools,

  PrjFormTLNReportSelection,

  PrjFormWirkungsKurven,
  PrjFormSeminarKenndaten,
  PrjFormDecisionData,
  PrjFormPeriodicData,
  PrjFormPeriodenUnabhaengigeDaten,
  PrjFormAusgangsLoesung,
  PrjDialogLogin,
  PrjFormPDFDisplay;

procedure TPrjFormsMain.btnAusgangsLoesungClick(Sender: TObject);
var LPrjAusgangLoesung : TPrjFormsAusgangsLoesung;
  procedure AfterCreate(AForm: TObject);
  begin
    if Assigned(LPrjAusgangLoesung) and (LPrjAusgangLoesung is TPrjFormsAusgangsLoesung) then
    begin
      WaitMessage.Hide;
      window.location.hash  := 'TPrjFormsAusgangsLoesung';  // used to manage Back button handling to close subform
      ( LPrjAusgangLoesung as TPrjFormsAusgangsLoesung ).Init;
      ( LPrjAusgangLoesung as TPrjFormsAusgangsLoesung ).Caption  := 'Ausgangslösung';
    end;
  end;
  procedure AfterShowModal(AValue: TModalResult);
  begin
    ( LPrjAusgangLoesung as TPrjFormsAusgangsLoesung ).Done;
    // Hier können wir jetzt alles sichern
  end;
begin
  WaitMessage.Show;
  LPrjAusgangLoesung              := TPrjFormsAusgangsLoesung.CreateNew(@AfterCreate);
  LPrjAusgangLoesung.ShowModal(@AfterShowModal);
end;

procedure TPrjFormsMain.btnCalculateActPeriodClick(Sender: TObject);
begin
  FPeriodCalculationType := ctpActualPeriod;
  CalculatePeriods;
end;

procedure TPrjFormsMain.btnCalculateNextPeriodClick(Sender: TObject);
begin
  FPeriodCalculationType := ctpNextPeriod;
  CalculatePeriods;
end;

procedure TPrjFormsMain.btnEntscheidungsdatenClick(Sender: TObject);
var LPrjFormsDescisionData : TPrjFormsDecisionData;
  procedure AfterCreate(AForm: TObject);
  begin
    if Assigned(LPrjFormsDescisionData) and (LPrjFormsDescisionData is TPrjFormsDecisionData) then
    begin
      window.location.hash  := 'TPrjFormsDescisionData';  // used to manage Back button handling to close subform
      ( LPrjFormsDescisionData as TPrjFormsDecisionData ).CallingForm := wxFrmMainFormSPL;
      ( LPrjFormsDescisionData as TPrjFormsDecisionData ).btnSaveAndLock.Enabled  := false;
      ( LPrjFormsDescisionData as TPrjFormsDecisionData ).btnSave.Enabled         := false;
      ( LPrjFormsDescisionData as TPrjFormsDecisionData ).Init;
      ( LPrjFormsDescisionData as TPrjFormsDecisionData ).Caption  := 'Eingabe Entscheidungsdaten';
    end;
  end;
  procedure AfterShowModal(AValue: TModalResult);
  begin
    ( LPrjFormsDescisionData as TPrjFormsDecisionData ).Done;
    // Hier können wir jetzt alles sichern
  end;
begin
  LPrjFormsDescisionData := TPrjFormsDecisionData.CreateNew(@AfterCreate);
  LPrjFormsDescisionData.ShowModal(@AfterShowModal);
end;

procedure TPrjFormsMain.btnLogoutClick(Sender: TObject);
begin
  ShowLogOnDialog;
end;

procedure TPrjFormsMain.btnPeriodenAbhaengigeDatenClick(Sender: TObject);
var LPrjPeriodicData : TPrjFormsPeriodicData;
var LResult : Boolean;
  procedure AfterCreate(AForm: TObject);
  begin
    if Assigned(LPrjPeriodicData) and (LPrjPeriodicData is TPrjFormsPeriodicData) then
    begin
      WaitMessage.Hide;
      window.location.hash  := 'TPrjFormsPeriodicData';  // used to manage Back button handling to close subform
      ( LPrjPeriodicData as TPrjFormsPeriodicData ).Init;
      ( LPrjPeriodicData as TPrjFormsPeriodicData ).Caption  := 'Periodenabhängige Daten';
    end;
  end;
  procedure AfterShowModal(AValue: TModalResult);
  begin
    ( LPrjPeriodicData as TPrjFormsPeriodicData ).Done;
    // Hier können wir jetzt alles sichern
  end;
begin
  WaitMessage.Show;
  LPrjPeriodicData  :=  TPrjFormsPeriodicData.CreateNew(@AfterCreate);
  LPrjPeriodicData.ShowModal(@AfterShowModal);
end;

procedure TPrjFormsMain.btnPeriodenUnabhaengigeDatenClick(Sender: TObject);
var LPrjPeriodicUnabData : TPrjFormsPeriodenUnabhaengigeDaten;
  procedure AfterCreate(AForm: TObject);
  begin
    if Assigned(LPrjPeriodicUnabData) and (LPrjPeriodicUnabData is TPrjFormsPeriodenUnabhaengigeDaten) then
    begin
      window.location.hash  := 'TPrjFormsPeriodenUnabhaengigeDaten';  // used to manage Back button handling to close subform
      ( LPrjPeriodicUnabData as TPrjFormsPeriodenUnabhaengigeDaten ).Init;
      ( LPrjPeriodicUnabData as TPrjFormsPeriodenUnabhaengigeDaten ).Caption  := 'Perioden Unabhängige Daten';
    end;
  end;
  procedure AfterShowModal(AValue: TModalResult);
  begin
    ( LPrjPeriodicUnabData as TPrjFormsPeriodenUnabhaengigeDaten ).Done;
    // Hier können wir jetzt alles sichern
  end;
begin
  LPrjPeriodicUnabData  :=  TPrjFormsPeriodenUnabhaengigeDaten.CreateNew(@AfterCreate);
  LPrjPeriodicUnabData.ShowModal(@AfterShowModal);
end;

procedure TPrjFormsMain.btnQuickMVZClick(Sender: TObject);
var LPrjPeriodicData  : TPrjFormsPeriodicData;
var LResult           : Boolean;
  procedure AfterCreate(AForm: TObject);
  begin
    if Assigned(LPrjPeriodicData) and (LPrjPeriodicData is TPrjFormsPeriodicData) then
    begin
      window.location.hash  := 'TPrjFormsPeriodicData';  // used to manage Back button handling to close subform
      ( LPrjPeriodicData as TPrjFormsPeriodicData ).Init;
      ( LPrjPeriodicData as TPrjFormsPeriodicData ).Caption  := 'Periodenabhängige Daten';
    end;
  end;
  procedure AfterShowModal(AValue: TModalResult);
  begin
    ( LPrjPeriodicData as TPrjFormsPeriodicData ).Done;
    // Hier können wir jetzt alles sichern
  end;
begin
  LPrjPeriodicData  :=  TPrjFormsPeriodicData.CreateNew(@AfterCreate);
  LPrjPeriodicData.SelectedPageIndex := 0;
  LPrjPeriodicData.ShowModal(@AfterShowModal);
end;


function TPrjFormsMain.ResetSimulation: boolean;
var LModalResult : TModalResult;
var LResult : boolean;
var LToken : string;
begin
  Result := true;
  try
    LModalResult := await(TModalResult, WebMessageDlg.ShowDialog(cResetSimulations, mtConfirmation, [mbYes,mbNo]));
    if LModalResult = mrYes then
    begin
      LModalResult := await(TModalResult, WebMessageDlg.ShowDialog(cResetSimLogOutWarning, mtConfirmation, [mbYes,mbNo]));
      if LModalResult = mrYes then
      begin
        try
          DataModule.HBMDefaultData.CalculatedDepartment  := DataModule.HBMDefaultData.AktuelleAbteilung;
          DataModule.HBMDefaultData.CalculatedEnterprise  := DataModule.HBMDefaultData.AktuellesUnternehmen;
          DataModule.HBMDefaultData.CalculatedPeriod      := DataModule.HBMDefaultData.AktuellePeriode;

          WaitMessage.Show;

          {$IFDEF APPISTLN}
          LResult := await(DataAccess.RequestDaten('R', HBMMainT.XDataWebConnectionMain ));
          {$ELSE}
          LResult := await(DataAccess.RequestDaten('R', PrjFormsMain.XDataWebConnectionMain ));
          {$ENDIF}

          WaitMessage.Hide;
          if Result then
          begin
            if Await(Self.GetNewToken) then
            begin
              Self.PerformReInitialRun;
              Self.ToggleGUI;
              LModalResult := await(TModalResult, WebMessageDlg.ShowDialog(cResetSimuOkMsg, mtInformation, [mbOK]));
            end;
          end else
          begin
            LModalResult := await(TModalResult, WebMessageDlg.ShowDialog(cResetSimuNotOkMsg, mtInformation, [mbOK]));
          end;

        except
          result := false;
        end;
      end else
      begin
        result := false;
      end;
    end else
    begin
      result := false;
    end;
  finally
    WaitMessage.Hide;
  end;
end;


function TPrjFormsMain.ResetPaswwords: Boolean;
var LModalResult : TModalResult;
begin
  Result := true;
  try
    LModalResult := await(TModalResult, WebMessageDlg.ShowDialog(cResetPasswords, mtConfirmation, [mbYes,mbNo]));
    if LModalResult = mrYes then
    begin
      try
        DataModule.HBMDefaultData.CalculatedDepartment  := DataModule.HBMDefaultData.AktuelleAbteilung;
        DataModule.HBMDefaultData.CalculatedEnterprise  := DataModule.HBMDefaultData.AktuellesUnternehmen;
        DataModule.HBMDefaultData.CalculatedPeriod      := DataModule.HBMDefaultData.AktuellePeriode;

        WaitMessage.Show;

        {$IFDEF APPISTLN}
        await(DataAccess.RequestDaten('X', HBMMainT.XDataWebConnectionMain ));
        {$ELSE}
        await(DataAccess.RequestDaten('X', PrjFormsMain.XDataWebConnectionMain ));
        {$ENDIF}
      except
        result := false;
      end;
    end else
    begin
      result := false;
    end;
  finally
    WaitMessage.Hide;
  end;
end;

function TPrjFormsMain.PreCheckCalculatePeriod: Boolean;
begin
  Result := false;
  DataModule.HBMDefaultData.CalculatedDepartment  := DataModule.HBMDefaultData.AktuelleAbteilung;
  DataModule.HBMDefaultData.CalculatedEnterprise  := DataModule.HBMDefaultData.AktuellesUnternehmen;
  DataModule.HBMDefaultData.CalculatedPeriod      := DataModule.HBMDefaultData.AktuellePeriode;

  WaitMessage.Show;
  try
    {$IFDEF APPISTLN}
    await(DataAccess.RequestDaten('N', HBMMainT.XDataWebConnectionMain,'CHECK' ));
    {$ELSE}
    await(DataAccess.RequestDaten('N', PrjFormsMain.XDataWebConnectionMain,'CHECK' ));
    {$ENDIF}
  finally
    WaitMessage.Hide;
  end;
end;

function TPrjFormsMain.CalculateNextPeriod: Boolean;
begin
  Result := true;
  DataModule.HBMDefaultData.CalculatedDepartment  := DataModule.HBMDefaultData.AktuelleAbteilung;
  DataModule.HBMDefaultData.CalculatedEnterprise  := DataModule.HBMDefaultData.AktuellesUnternehmen;
  DataModule.HBMDefaultData.CalculatedPeriod      := DataModule.HBMDefaultData.AktuellePeriode;

  WaitMessage.Show;
  try
    if FPeriodCalculationType = ctpActualPeriod then
    begin
      {$IFDEF APPISTLN}
      await(DataAccess.RequestDaten('N', HBMMainT.XDataWebConnectionMain ));
      {$ELSE}
      await(DataAccess.RequestDaten('N', PrjFormsMain.XDataWebConnectionMain ));
      {$ENDIF}
    end;
    if FPeriodCalculationType = ctpNextPeriod then
    begin
      {$IFDEF APPISTLN}
      await(DataAccess.RequestDaten('O', HBMMainT.XDataWebConnectionMain ));
      {$ELSE}
      await(DataAccess.RequestDaten('O', PrjFormsMain.XDataWebConnectionMain ));
      {$ENDIF}
    end;
  finally
    WaitMessage.Hide;
  end;
end;

function TPrjFormsMain.GetNewToken: Boolean;
var LToken : string;
begin
  Result := true;
  WaitMessage.Show;
  try
    {$IFDEF APPISTLN}
    LToken := await(DataAccess.RequestAuthentication('T', HBMMainT.XDataWebConnectionMain ));
    {$ELSE}
    LToken := await(DataAccess.RequestAuthentication('T', PrjFormsMain.XDataWebConnectionMain ));
    {$ENDIF}

    if LToken <> 'NOK' then
    begin
      DataModule.TokenInformation.BuildJWTStorageName(LToken);
      DataModule.TokenInformation.WriteTokenInfo;
    end else
      Result := false;
  finally
    WaitMessage.Hide;
  end;
end;

procedure TPrjFormsMain.WebFormCreate(Sender: TObject);
begin
  XDataWebConnectionMain.Connected        := false;
  FLocalStorage                           := TLocalStorage.Create(Self);
  FLocalStorage.Values['LoggedIn']        := '0';
  FLocalStorage.Values['LoggedInTime']    := FormatDateTime('dd.mm.yyyy hh:mm:ss',Now);
  Caption                                 := 'HBM Online Spielleiter';
  ApplicationType                         := atSpielleiter;
  XDataWebConnectionMain.URL              := cXDataServerUrl;
  XDataWebConnectionMain.Connected        := true;
  Application.ErrorType                   := aeSilent;
  FPeriodCalculationType                  := ctpNone;
  ToggleGUI;
end;

procedure TPrjFormsMain.WebFormDestroy(Sender: TObject);
begin
  inherited;
  FLocalStorage.Free;
end;

function TPrjFormsMain.GetLoggedOn: Boolean;
begin
  Result := DataModule.TokenInformation.AccessInfo <> '';
end;

procedure TPrjFormsMain.SetMenuEnable(Value: boolean = false);
begin
  pnSimulation.Enabled          := Value;
  pnEntscheidungsdaten.Enabled  := Value;
  pnBerechnung.Enabled          := Value;
  pnBerichte.Enabled            := Value;
  pnNavBar.Enabled              := Value;
end;

function TPrjFormsMain.ShowLogOnDialog(AMessage: string = ''): Boolean;
begin
  Result := false;
  if AMessage <> '' then
  begin
    AMessage := 'Server is down for maintenance... Try again later ';
  end;
  result := await(LoginDlg(XDataWebConnectionMain, atSpielleiter, AMessage));
end;

procedure TPrjFormsMain.ToggleGUI;
begin
  if DataModule.TokenInformation.isValidToken then
  begin
    btnCalculateNextPeriod.Caption  := '<i class="bi bi-calculator"></i> nächstes Geschäftsjahr [ ' + IntToStr(DataModule.TokenInformation.PeriodId + 1) + ' ] berechnen';
    btnCalculateActPeriod.Caption   := '<i class="bi bi-arrow-counterclockwise"></i>Berechnung des aktuellen Geschäftsjahres [ ' + DataModule.TokenInformation.PeriodId.ToString + ' ] wiederholen';
  end;
end;

procedure TPrjFormsMain.PerformReInitialRun;
begin
  try
    DataAccess.DataConnection := XDataWebConnectionMain;
    XDataWebDataSetModul.QueryString := '$filter=(Upmd_Simulation_Id eq ' + DataAccess.AktuelleSimulation.toString  + ')';
    await(XDataWebDataSetModul.Load);
    if await(DataAccess.InitializeSession) then
    begin
      btnWirkungskurven.Enabled       := true;
      btnWirkungskurven.Visible       := true;
      btnCalculateNextPeriod.Caption  := '<i class="bi bi-calculator"></i> nächstes Geschäftsjahr [ ' + IntToStr(DataModule.TokenInformation.PeriodId + 1) + ' ] berechnen';
      btnCalculateActPeriod.Caption   := '<i class="bi bi-arrow-counterclockwise"></i> aktuelles Geschäftsjahr [ ' + DataModule.TokenInformation.PeriodId.ToString + ' ] wiederholen';
    end;
  except
    wxBaseWriteLog.Write('exception occured in TPrjFormsMain.PerformReInitialRun',slError);
  end;
end;

procedure TPrjFormsMain.PerformInitialRun(AMessage: string = '');
begin
  try
    if await(ShowLogOnDialog(AMessage)) then
    begin
      DataAccess.DataConnection := XDataWebConnectionMain;
      XDataWebDataSetModul.QueryString := '$filter=(Upmd_Simulation_Id eq ' + DataAccess.AktuelleSimulation.toString  + ')';

      DataModule.TokenInformation.WriteTokenInfo;

      await(XDataWebDataSetModul.Load);

      if await(DataAccess.InitializeSession) then
      begin
        btnWirkungskurven.Enabled       := false;
        btnWirkungskurven.Visible       := false;
        btnCalculateNextPeriod.Caption  := '<i class="bi bi-calculator"></i> nächstes Geschäftsjahr [ ' + IntToStr(DataModule.TokenInformation.PeriodId + 1) + ' ] berechnen';
        btnCalculateActPeriod.Caption   := '<i class="bi bi-arrow-counterclockwise"></i>Berechnung des aktuellen Geschäftsjahres [ ' + DataModule.TokenInformation.PeriodId.ToString + ' ] wiederholen';
      end;
    end;
  except
    wxBaseWriteLog.Write('exception occured in TPrjFormsMain.PerformInitialRun',slError);
    AMessage := 'exception occured in TPrjFormsMain.PerformInitialRun';
  end;
end;

procedure TPrjFormsMain.btnRestePasswordClick(Sender: TObject);
begin
  ResetPaswwords;
end;

procedure TPrjFormsMain.btnQuickZweckMittelClick(Sender: TObject);
var LPrjPeriodicData : TPrjFormsPeriodicData;
var LResult : Boolean;
  procedure AfterCreate(AForm: TObject);
  begin
    if Assigned(LPrjPeriodicData) and (LPrjPeriodicData is TPrjFormsPeriodicData) then
    begin
      window.location.hash  := 'TPrjFormsPeriodicData';  // used to manage Back button handling to close subform
      ( LPrjPeriodicData as TPrjFormsPeriodicData ).Init;
      ( LPrjPeriodicData as TPrjFormsPeriodicData ).Caption  := 'Periodenabhängige Daten';
    end;
  end;
  procedure AfterShowModal(AValue: TModalResult);
  begin
    ( LPrjPeriodicData as TPrjFormsPeriodicData ).Done;
    // Hier können wir jetzt alles sichern
  end;
begin
  LPrjPeriodicData  :=  TPrjFormsPeriodicData.CreateNew(@AfterCreate);
  LPrjPeriodicData.SelectedPageIndex := 3;
  LPrjPeriodicData.ShowModal(@AfterShowModal);
end;

procedure TPrjFormsMain.btnResetSimulationClick(Sender: TObject);
begin
  ResetSimulation;
end;

procedure TPrjFormsMain.btnSeminarKennDatenClick(Sender: TObject);
var LPrjFormsSeminarKennDaten : TPrjFormsSeminarKenndaten;
  procedure AfterCreate(AForm: TObject);
  begin
    if Assigned(LPrjFormsSeminarKennDaten) and (LPrjFormsSeminarKennDaten is TPrjFormsSeminarKenndaten) then
    begin
      WaitMessage.Hide;
      window.location.hash  := 'TPrjFormsSeminarKenndaten';  // used to manage Back button handling to close subform
      ( LPrjFormsSeminarKennDaten as TPrjFormsSeminarKenndaten ).Init;
      ( LPrjFormsSeminarKennDaten as TPrjFormsSeminarKenndaten ).Caption  := 'Seminar Kenndaten';
    end;
  end;
  procedure AfterShowModal(AValue: TModalResult);
  begin
    ( LPrjFormsSeminarKennDaten as TPrjFormsSeminarKenndaten ).Done;
    Self.GetNewToken;
    ToggleGUI;   //Aktualisiert die periodennummern im menü
  end;
begin
  WaitMessage.Show;
  LPrjFormsSeminarKennDaten              := TPrjFormsSeminarKenndaten.CreateNew(@AfterCreate);
  LPrjFormsSeminarKennDaten.Popup        := true;
  LPrjFormsSeminarKennDaten.PopupOpacity := 0.2;
  LPrjFormsSeminarKennDaten.ShowModal(@AfterShowModal);
end;

procedure TPrjFormsMain.btnSPLReportPrintClick(Sender: TObject);
var LReportSelection : TPrjFormsTLNReportSelection;
  procedure AfterCreate(AForm: TObject);
  begin
    if Assigned(LReportSelection) and (LReportSelection is TPrjFormsTLNReportSelection) then
    begin
      window.location.hash := 'TPrjFormsTLNReportSelection';
      ( LReportSelection as TPrjFormsTLNReportSelection ).lblPeriode.Visible  := true;
      ( LReportSelection as TPrjFormsTLNReportSelection ).lblPeriode.Caption  := 'Krankenhaus ' + DataModule.HBMDefaultData.AktuellesUnternehmen.ToString;;
      ( LReportSelection as TPrjFormsTLNReportSelection ).spedPeriode.Enabled := true;
      ( LReportSelection as TPrjFormsTLNReportSelection ).spedPeriode.Visible := true;
      ( LReportSelection as TPrjFormsTLNReportSelection ).spedPeriode.Value   := DataModule.HBMDefaultData.AktuellesUnternehmen;
      ( LReportSelection as TPrjFormsTLNReportSelection ).FormIdentifier      := wxFrmPrintSPLReports;
      ( LReportSelection as TPrjFormsTLNReportSelection ).Init;
      ( LReportSelection as TPrjFormsTLNReportSelection ).Caption  := 'Spielleiter Berichte';
    end;
  end;
  procedure AfterShowModal(AValue: TModalResult);
  begin
    // Hier können wir jetzt alles machen was nach dem schließen des Fensters sein muss
  end;
begin
  LReportSelection              := TPrjFormsTLNReportSelection.CreateNew( @AfterCreate);
  LReportSelection.Popup        := true;
  LReportSelection.PopupOpacity := 0.2;
  LReportSelection.ShowModal(@AfterShowModal);
end;

procedure TPrjFormsMain.btnTLNReportPrintClick(Sender: TObject);
var LReportSelection : TPrjFormsTLNReportSelection;
  procedure AfterCreate(AForm: TObject);
  begin
    if Assigned(LReportSelection) and (LReportSelection is TPrjFormsTLNReportSelection) then
    begin
      window.location.hash := 'TPrjFormsTLNReportSelection';
      ( LReportSelection as TPrjFormsTLNReportSelection ).FormIdentifier      := wxFrmPrintTLNReports;
      ( LReportSelection as TPrjFormsTLNReportSelection ).Init;
      ( LReportSelection as TPrjFormsTLNReportSelection ).Caption  := 'Teilnehmer Berichte';
    end;
  end;
  procedure AfterShowModal(AValue: TModalResult);
  begin
    // Hier können wir jetzt alles machen was nach dem schließen des Fensters sein muss
  end;
begin
  LReportSelection              := TPrjFormsTLNReportSelection.CreateNew( @AfterCreate);
  LReportSelection.Popup        := true;
  LReportSelection.PopupOpacity := 0.2;
  LReportSelection.ShowModal(@AfterShowModal);
end;

procedure TPrjFormsMain.btnWirkungskurvenClick(Sender: TObject);
var LPrjFormWirkungsKurven : TPrjFormsWirkungsKurven;
  procedure AfterCreate(AForm: TObject);
  begin
    if Assigned(LPrjFormWirkungsKurven) and (LPrjFormWirkungsKurven is TPrjFormsWirkungsKurven) then
    begin
      WaitMessage.Hide;
      window.location.hash  := 'TPrjFormsWirkungsKurven';  // used to manage Back button handling to close subform
      ( LPrjFormWirkungsKurven as TPrjFormsWirkungsKurven ).Init;
      ( LPrjFormWirkungsKurven as TPrjFormsWirkungsKurven ).Caption  := 'Kurveneingabe';
    end;
  end;
  procedure AfterShowModal(AValue: TModalResult);
  begin
    ( LPrjFormWirkungsKurven as TPrjFormsWirkungsKurven ).Done;
    // Hier können wir jetzt alles sichern
  end;
begin
  WaitMessage.Show;
  LPrjFormWirkungsKurven              := TPrjFormsWirkungsKurven.CreateNew(@AfterCreate);
  LPrjFormWirkungsKurven.ShowModal(@AfterShowModal);
end;

function TPrjFormsMain.CalculatePeriods: Boolean;
var LModalResult  : TModalResult;
var LResponse     : TXDataClientResponse;
var LToken        : string;
begin
  btnCalculateActPeriod.Enabled   := false;
  btnCalculateNextPeriod.Enabled  := false;

  Result := await(CalculateNextPeriod);

  if result then
  begin
//    LToken := Await(Self.GetNewToken);
//    if LToken <> 'NOK' then
//    begin
//      DataModule.TokenInformation.BuildJWTStorageName(LToken);
//    end;
//
//    DataModule.TokenInformation.WriteTokenInfo;

    if Await(Self.GetNewToken) then
    begin
      await(PerformReInitialRun);
      if FPeriodCalculationType = ctpActualPeriod then
        LModalResult := await(TModalResult, WebMessageDlg.ShowDialog(cCalculateActPeriodOKMsg, mtInformation, [mbOK]))
      else
        LModalResult := await(TModalResult, WebMessageDlg.ShowDialog(cCalculateNextPeriodOKMsg, mtInformation, [mbOK]));
      btnCalculateActPeriod.Enabled   := true;
      btnCalculateNextPeriod.Enabled  := true;
    end;
  end else
  begin
    if FPeriodCalculationType = ctpNextPeriod then
      DataModule.HBMDefaultData.AktuellePeriode := DataModule.HBMDefaultData.AktuellePeriode - 1;
    LModalResult := await(TModalResult, WebMessageDlg.ShowDialog(cCalculatePeriodNotOkMsg, mtWarning, [mbCancel]));
    btnCalculateActPeriod.Enabled   := true;
    btnCalculateNextPeriod.Enabled  := true;
  end;
end;

procedure TPrjFormsMain.XDataWebConnectionMainConnect(Sender: TObject);
begin
  PerformInitialRun;
end;

procedure TPrjFormsMain.XDataWebConnectionMainError(Error: TXDataWebConnectionError);
begin
  wxBaseWriteLog.Write('error executing a request ' + Error.ErrorMessage, slDebug);
  PerformInitialRun('Error connecting to Server [' + XDataWebConnectionMain.URL + ']');
end;

procedure TPrjFormsMain.XDataWebDataSetModulAfterOpen(DataSet: TDataSet);
begin
  if not XDataWebDataSetModul.IsEmpty then
  begin
    DataModule.HBMDefaultData.Vorkalkulation        := XDataWebDataSetModul.FieldByName('Upmd_Period_Precalc_Allowed').AsInteger;
    DataModule.HBMDefaultData.LaundryOutsourced     := XDataWebDataSetModul.FieldByName('Upmd_Period_Outsourcing_Cleaning').AsInteger;
    DataModule.HBMDefaultData.CodierCaseManagement  := XDataWebDataSetModul.FieldByName('Upmd_Period_Case_Management').AsInteger;
  end else
  begin
    wxBaseWriteLog.Write('error opening independant periodic modul data',slError);
  end;
end;

procedure TPrjFormsMain.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnNavBar := TPanel.Create('navbar');
  btnLogout := TButton.Create('logoutButton');
  pnSimulation := TPanel.Create('pnSimulation');
  WebLabel5 := TLabel.Create('pnSimulationDescription');
  WebLabel2 := TLabel.Create('pnSimulationHeadline');
  WebLabel3 := TLabel.Create('pnSimulationQuickActionsHeadline');
  WebLabel4 := TLabel.Create('pnSimulationEingabeHeadline');
  btnResetSimulation := TButton.Create('resetSimulationButton');
  btnRestePassword := TButton.Create('resetPasswortButton');
  btnSeminarKennDaten := TButton.Create('seminarKenndatenButton');
  btnAusgangsLoesung := TButton.Create('ausgangsloesungButton');
  btnPeriodenUnabhaengigeDaten := TButton.Create('periodenunabhaengigeDatenButton');
  btnWirkungskurven := TButton.Create('wirkungskurvenButton');
  pnEntscheidungsdaten := TPanel.Create('pnEntscheidungsdaten');
  WebLabel6 := TLabel.Create('pnEntscheidungsdatenHeadline');
  WebLabel7 := TLabel.Create('pnEntscheidungsdatenQuickActionsHeadline');
  WebLabel8 := TLabel.Create('pnEntscheidungsdatenEingabeHeadline');
  WebLabel9 := TLabel.Create('pnEntscheidungsdatenDescription');
  btnQuickZweckMittel := TButton.Create('zweckgebundeneFoerdermittelButton');
  btnQuickMVZ := TButton.Create('mvzEroeffnenButton');
  btnEntscheidungsdaten := TButton.Create('entscheidungsdatenButton');
  btnPeriodenAbhaengigeDaten := TButton.Create('periodenabhaengigeButton');
  pnBerechnung := TPanel.Create('pnBerechnung');
  WebLabel10 := TLabel.Create('pnBerechnungHeadline');
  WebLabel11 := TLabel.Create('pnBerechnungDescription');
  WebLabel12 := TLabel.Create('pnBerechnungQuickActionsHeadline');
  btnCalculateActPeriod := TButton.Create('berechnungWiederholenButton');
  btnCalculateNextPeriod := TButton.Create('berechnenButton');
  pnBerichte := TPanel.Create('pnBerichte');
  WebLabel13 := TLabel.Create('pnBerichteHeadline');
  WebLabel14 := TLabel.Create('pnBerichteDescription');
  WebLabel15 := TLabel.Create('pnBerichteEingabeHeadline');
  btnTLNReportPrint := TButton.Create('tlnBerichteButton');
  btnSPLReportPrint := TButton.Create('splBerichteButton');
  WebMessageDlg := TMessageDlg.Create(Self);
  XDataWebConnectionMain := TXDataWebConnection.Create(Self);
  XDataWebDataSetModul := TXDataWebDataSet.Create(Self);

  WaitMessage.BeforeLoadDFMValues;
  pnNavBar.BeforeLoadDFMValues;
  btnLogout.BeforeLoadDFMValues;
  pnSimulation.BeforeLoadDFMValues;
  WebLabel5.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  btnResetSimulation.BeforeLoadDFMValues;
  btnRestePassword.BeforeLoadDFMValues;
  btnSeminarKennDaten.BeforeLoadDFMValues;
  btnAusgangsLoesung.BeforeLoadDFMValues;
  btnPeriodenUnabhaengigeDaten.BeforeLoadDFMValues;
  btnWirkungskurven.BeforeLoadDFMValues;
  pnEntscheidungsdaten.BeforeLoadDFMValues;
  WebLabel6.BeforeLoadDFMValues;
  WebLabel7.BeforeLoadDFMValues;
  WebLabel8.BeforeLoadDFMValues;
  WebLabel9.BeforeLoadDFMValues;
  btnQuickZweckMittel.BeforeLoadDFMValues;
  btnQuickMVZ.BeforeLoadDFMValues;
  btnEntscheidungsdaten.BeforeLoadDFMValues;
  btnPeriodenAbhaengigeDaten.BeforeLoadDFMValues;
  pnBerechnung.BeforeLoadDFMValues;
  WebLabel10.BeforeLoadDFMValues;
  WebLabel11.BeforeLoadDFMValues;
  WebLabel12.BeforeLoadDFMValues;
  btnCalculateActPeriod.BeforeLoadDFMValues;
  btnCalculateNextPeriod.BeforeLoadDFMValues;
  pnBerichte.BeforeLoadDFMValues;
  WebLabel13.BeforeLoadDFMValues;
  WebLabel14.BeforeLoadDFMValues;
  WebLabel15.BeforeLoadDFMValues;
  btnTLNReportPrint.BeforeLoadDFMValues;
  btnSPLReportPrint.BeforeLoadDFMValues;
  WebMessageDlg.BeforeLoadDFMValues;
  XDataWebConnectionMain.BeforeLoadDFMValues;
  XDataWebDataSetModul.BeforeLoadDFMValues;
  try
    Width := 1480;
    Height := 1010;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnDestroy', 'WebFormDestroy');
    WaitMessage.Left := 544;
    WaitMessage.Top := 305;
    WaitMessage.Picture.LoadFromFile('PrjFormMain.WaitMessage.Picture.gif');
    pnNavBar.SetParentComponent(Self);
    pnNavBar.Name := 'pnNavBar';
    pnNavBar.Left := 128;
    pnNavBar.Top := 40;
    pnNavBar.Width := 1193;
    pnNavBar.Height := 65;
    pnNavBar.ChildOrder := 1;
    pnNavBar.ElementFont := efCSS;
    pnNavBar.TabOrder := 1;
    btnLogout.SetParentComponent(pnNavBar);
    btnLogout.Name := 'btnLogout';
    btnLogout.Left := 1025;
    btnLogout.Top := 24;
    btnLogout.Width := 96;
    btnLogout.Height := 25;
    btnLogout.Caption := '<i class="bi bi-box-arrow-right"></i> Logout';
    btnLogout.ChildOrder := 1;
    btnLogout.ElementFont := efCSS;
    btnLogout.HeightStyle := ssAuto;
    btnLogout.HeightPercent := 100.00000000000000000;
    btnLogout.WidthPercent := 100.00000000000000000;
    SetEvent(btnLogout, Self, 'OnClick', 'btnLogoutClick');
    pnSimulation.SetParentComponent(Self);
    pnSimulation.Name := 'pnSimulation';
    pnSimulation.Left := 128;
    pnSimulation.Top := 176;
    pnSimulation.Width := 545;
    pnSimulation.Height := 385;
    pnSimulation.ChildOrder := 2;
    pnSimulation.ElementFont := efCSS;
    pnSimulation.Enabled := False;
    pnSimulation.TabOrder := 2;
    WebLabel5.SetParentComponent(pnSimulation);
    WebLabel5.Name := 'WebLabel5';
    WebLabel5.Left := -321;
    WebLabel5.Top := 56;
    WebLabel5.Width := 665;
    WebLabel5.Height := 18;
    WebLabel5.Caption := 'Hier k'#246'nnen alle Daten f'#252'r den Start oder die Korrektur einer laufenden Simulation eingegeben werden.';
    WebLabel5.ElementFont := efCSS;
    WebLabel5.HeightStyle := ssAuto;
    WebLabel5.HeightPercent := 100.00000000000000000;
    WebLabel5.HTMLType := tP;
    WebLabel5.WidthPercent := 100.00000000000000000;
    WebLabel2.SetParentComponent(pnSimulation);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 48;
    WebLabel2.Top := 32;
    WebLabel2.Width := 64;
    WebLabel2.Height := 18;
    WebLabel2.Caption := 'Simulation';
    WebLabel2.ElementFont := efCSS;
    WebLabel2.HeightStyle := ssAuto;
    WebLabel2.HeightPercent := 100.00000000000000000;
    WebLabel2.HTMLType := tH2;
    WebLabel2.WidthPercent := 100.00000000000000000;
    WebLabel3.SetParentComponent(pnSimulation);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 48;
    WebLabel3.Top := 104;
    WebLabel3.Width := 86;
    WebLabel3.Height := 18;
    WebLabel3.Caption := 'Quick-Actions';
    WebLabel3.ElementFont := efCSS;
    WebLabel3.HeightStyle := ssAuto;
    WebLabel3.HeightPercent := 100.00000000000000000;
    WebLabel3.HTMLType := tH3;
    WebLabel3.WidthPercent := 100.00000000000000000;
    WebLabel4.SetParentComponent(pnSimulation);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 48;
    WebLabel4.Top := 233;
    WebLabel4.Width := 50;
    WebLabel4.Height := 18;
    WebLabel4.Caption := 'Eingabe';
    WebLabel4.ElementFont := efCSS;
    WebLabel4.HeightStyle := ssAuto;
    WebLabel4.HeightPercent := 100.00000000000000000;
    WebLabel4.HTMLType := tH3;
    WebLabel4.WidthPercent := 100.00000000000000000;
    btnResetSimulation.SetParentComponent(pnSimulation);
    btnResetSimulation.Name := 'btnResetSimulation';
    btnResetSimulation.Left := 48;
    btnResetSimulation.Top := 136;
    btnResetSimulation.Width := 96;
    btnResetSimulation.Height := 25;
    btnResetSimulation.Caption := '<i class="bi bi-arrow-counterclockwise"></i> Simulation zur'#252'cksetzen';
    btnResetSimulation.ChildOrder := 1;
    btnResetSimulation.ElementFont := efCSS;
    btnResetSimulation.HeightStyle := ssAuto;
    btnResetSimulation.HeightPercent := 100.00000000000000000;
    btnResetSimulation.WidthPercent := 100.00000000000000000;
    SetEvent(btnResetSimulation, Self, 'OnClick', 'btnResetSimulationClick');
    btnRestePassword.SetParentComponent(pnSimulation);
    btnRestePassword.Name := 'btnRestePassword';
    btnRestePassword.Left := 200;
    btnRestePassword.Top := 136;
    btnRestePassword.Width := 96;
    btnRestePassword.Height := 25;
    btnRestePassword.Caption := '<i class="bi bi-stars"></i> TLN-Passw'#246'rter zur'#252'cksetzen';
    btnRestePassword.ChildOrder := 2;
    btnRestePassword.ElementFont := efCSS;
    btnRestePassword.HeightStyle := ssAuto;
    btnRestePassword.HeightPercent := 100.00000000000000000;
    btnRestePassword.WidthPercent := 100.00000000000000000;
    SetEvent(btnRestePassword, Self, 'OnClick', 'btnRestePasswordClick');
    btnSeminarKennDaten.SetParentComponent(pnSimulation);
    btnSeminarKennDaten.Name := 'btnSeminarKennDaten';
    btnSeminarKennDaten.Left := 48;
    btnSeminarKennDaten.Top := 287;
    btnSeminarKennDaten.Width := 96;
    btnSeminarKennDaten.Height := 25;
    btnSeminarKennDaten.Caption := 'Seminar-Kenndaten';
    btnSeminarKennDaten.ChildOrder := 5;
    btnSeminarKennDaten.ElementFont := efCSS;
    btnSeminarKennDaten.HeightStyle := ssAuto;
    btnSeminarKennDaten.HeightPercent := 100.00000000000000000;
    btnSeminarKennDaten.WidthPercent := 100.00000000000000000;
    SetEvent(btnSeminarKennDaten, Self, 'OnClick', 'btnSeminarKennDatenClick');
    btnAusgangsLoesung.SetParentComponent(pnSimulation);
    btnAusgangsLoesung.Name := 'btnAusgangsLoesung';
    btnAusgangsLoesung.Left := 200;
    btnAusgangsLoesung.Top := 288;
    btnAusgangsLoesung.Width := 96;
    btnAusgangsLoesung.Height := 25;
    btnAusgangsLoesung.Caption := 'Ausgangsl'#246'sung';
    btnAusgangsLoesung.ChildOrder := 6;
    btnAusgangsLoesung.ElementFont := efCSS;
    btnAusgangsLoesung.HeightStyle := ssAuto;
    btnAusgangsLoesung.HeightPercent := 100.00000000000000000;
    btnAusgangsLoesung.WidthPercent := 100.00000000000000000;
    SetEvent(btnAusgangsLoesung, Self, 'OnClick', 'btnAusgangsLoesungClick');
    btnPeriodenUnabhaengigeDaten.SetParentComponent(pnSimulation);
    btnPeriodenUnabhaengigeDaten.Name := 'btnPeriodenUnabhaengigeDaten';
    btnPeriodenUnabhaengigeDaten.Left := 336;
    btnPeriodenUnabhaengigeDaten.Top := 288;
    btnPeriodenUnabhaengigeDaten.Width := 96;
    btnPeriodenUnabhaengigeDaten.Height := 25;
    btnPeriodenUnabhaengigeDaten.Caption := 'Periodenunabh'#228'ngige Daten';
    btnPeriodenUnabhaengigeDaten.ChildOrder := 7;
    btnPeriodenUnabhaengigeDaten.ElementFont := efCSS;
    btnPeriodenUnabhaengigeDaten.HeightStyle := ssAuto;
    btnPeriodenUnabhaengigeDaten.HeightPercent := 100.00000000000000000;
    btnPeriodenUnabhaengigeDaten.WidthPercent := 100.00000000000000000;
    SetEvent(btnPeriodenUnabhaengigeDaten, Self, 'OnClick', 'btnPeriodenUnabhaengigeDatenClick');
    btnWirkungskurven.SetParentComponent(pnSimulation);
    btnWirkungskurven.Name := 'btnWirkungskurven';
    btnWirkungskurven.Left := 449;
    btnWirkungskurven.Top := 288;
    btnWirkungskurven.Width := 96;
    btnWirkungskurven.Height := 25;
    btnWirkungskurven.Caption := 'Wirkungskurven';
    btnWirkungskurven.ChildOrder := 7;
    btnWirkungskurven.ElementFont := efCSS;
    btnWirkungskurven.HeightStyle := ssAuto;
    btnWirkungskurven.HeightPercent := 100.00000000000000000;
    btnWirkungskurven.WidthPercent := 100.00000000000000000;
    SetEvent(btnWirkungskurven, Self, 'OnClick', 'btnWirkungskurvenClick');
    pnEntscheidungsdaten.SetParentComponent(Self);
    pnEntscheidungsdaten.Name := 'pnEntscheidungsdaten';
    pnEntscheidungsdaten.Left := 768;
    pnEntscheidungsdaten.Top := 176;
    pnEntscheidungsdaten.Width := 545;
    pnEntscheidungsdaten.Height := 385;
    pnEntscheidungsdaten.ChildOrder := 2;
    pnEntscheidungsdaten.ElementFont := efCSS;
    pnEntscheidungsdaten.Enabled := False;
    pnEntscheidungsdaten.TabOrder := 3;
    WebLabel6.SetParentComponent(pnEntscheidungsdaten);
    WebLabel6.Name := 'WebLabel6';
    WebLabel6.Left := 40;
    WebLabel6.Top := 32;
    WebLabel6.Width := 129;
    WebLabel6.Height := 18;
    WebLabel6.Caption := 'Entscheidungsdaten';
    WebLabel6.ElementFont := efCSS;
    WebLabel6.HeightStyle := ssAuto;
    WebLabel6.HeightPercent := 100.00000000000000000;
    WebLabel6.HTMLType := tH2;
    WebLabel6.WidthPercent := 100.00000000000000000;
    WebLabel7.SetParentComponent(pnEntscheidungsdaten);
    WebLabel7.Name := 'WebLabel7';
    WebLabel7.Left := 40;
    WebLabel7.Top := 104;
    WebLabel7.Width := 86;
    WebLabel7.Height := 18;
    WebLabel7.Caption := 'Quick-Actions';
    WebLabel7.ElementFont := efCSS;
    WebLabel7.HeightStyle := ssAuto;
    WebLabel7.HeightPercent := 100.00000000000000000;
    WebLabel7.HTMLType := tH3;
    WebLabel7.WidthPercent := 100.00000000000000000;
    WebLabel8.SetParentComponent(pnEntscheidungsdaten);
    WebLabel8.Name := 'WebLabel8';
    WebLabel8.Left := 40;
    WebLabel8.Top := 233;
    WebLabel8.Width := 50;
    WebLabel8.Height := 18;
    WebLabel8.Caption := 'Eingabe';
    WebLabel8.ElementFont := efCSS;
    WebLabel8.HeightStyle := ssAuto;
    WebLabel8.HeightPercent := 100.00000000000000000;
    WebLabel8.HTMLType := tH3;
    WebLabel8.WidthPercent := 100.00000000000000000;
    WebLabel9.SetParentComponent(pnEntscheidungsdaten);
    WebLabel9.Name := 'WebLabel9';
    WebLabel9.Left := -492;
    WebLabel9.Top := 64;
    WebLabel9.Width := 1037;
    WebLabel9.Height := 18;
    WebLabel9.Caption := 'Hier k'#246'nnen Sie die periodenabh'#228'ngigen Daten f'#252'r die Teilnehmenden konfigurieren. Weiterhin k'#246'nnen Sie die Entscheidungsdaten der Teilnehmenden einsehen.';
    WebLabel9.ElementFont := efCSS;
    WebLabel9.HeightStyle := ssAuto;
    WebLabel9.HeightPercent := 100.00000000000000000;
    WebLabel9.HTMLType := tP;
    WebLabel9.WidthPercent := 100.00000000000000000;
    btnQuickZweckMittel.SetParentComponent(pnEntscheidungsdaten);
    btnQuickZweckMittel.Name := 'btnQuickZweckMittel';
    btnQuickZweckMittel.Left := 40;
    btnQuickZweckMittel.Top := 136;
    btnQuickZweckMittel.Width := 96;
    btnQuickZweckMittel.Height := 25;
    btnQuickZweckMittel.Caption := '<i class="bi bi-fast-forward"></i> Zweckgebundene F'#246'rdermittel';
    btnQuickZweckMittel.ChildOrder := 1;
    btnQuickZweckMittel.ElementFont := efCSS;
    btnQuickZweckMittel.HeightStyle := ssAuto;
    btnQuickZweckMittel.HeightPercent := 100.00000000000000000;
    btnQuickZweckMittel.WidthPercent := 100.00000000000000000;
    SetEvent(btnQuickZweckMittel, Self, 'OnClick', 'btnQuickZweckMittelClick');
    btnQuickMVZ.SetParentComponent(pnEntscheidungsdaten);
    btnQuickMVZ.Name := 'btnQuickMVZ';
    btnQuickMVZ.Left := 192;
    btnQuickMVZ.Top := 136;
    btnQuickMVZ.Width := 96;
    btnQuickMVZ.Height := 25;
    btnQuickMVZ.Caption := '<i class="bi bi-skip-end-fill"></i> MVZ er'#246'ffnen';
    btnQuickMVZ.ChildOrder := 2;
    btnQuickMVZ.ElementFont := efCSS;
    btnQuickMVZ.HeightStyle := ssAuto;
    btnQuickMVZ.HeightPercent := 100.00000000000000000;
    btnQuickMVZ.WidthPercent := 100.00000000000000000;
    SetEvent(btnQuickMVZ, Self, 'OnClick', 'btnQuickMVZClick');
    btnEntscheidungsdaten.SetParentComponent(pnEntscheidungsdaten);
    btnEntscheidungsdaten.Name := 'btnEntscheidungsdaten';
    btnEntscheidungsdaten.Left := 40;
    btnEntscheidungsdaten.Top := 287;
    btnEntscheidungsdaten.Width := 96;
    btnEntscheidungsdaten.Height := 25;
    btnEntscheidungsdaten.Caption := 'Entscheidungsdaten';
    btnEntscheidungsdaten.ChildOrder := 5;
    btnEntscheidungsdaten.ElementFont := efCSS;
    btnEntscheidungsdaten.HeightStyle := ssAuto;
    btnEntscheidungsdaten.HeightPercent := 100.00000000000000000;
    btnEntscheidungsdaten.WidthPercent := 100.00000000000000000;
    SetEvent(btnEntscheidungsdaten, Self, 'OnClick', 'btnEntscheidungsdatenClick');
    btnPeriodenAbhaengigeDaten.SetParentComponent(pnEntscheidungsdaten);
    btnPeriodenAbhaengigeDaten.Name := 'btnPeriodenAbhaengigeDaten';
    btnPeriodenAbhaengigeDaten.Left := 192;
    btnPeriodenAbhaengigeDaten.Top := 288;
    btnPeriodenAbhaengigeDaten.Width := 96;
    btnPeriodenAbhaengigeDaten.Height := 25;
    btnPeriodenAbhaengigeDaten.Caption := 'Periodenabh'#228'ngige Daten';
    btnPeriodenAbhaengigeDaten.ChildOrder := 6;
    btnPeriodenAbhaengigeDaten.ElementFont := efCSS;
    btnPeriodenAbhaengigeDaten.HeightStyle := ssAuto;
    btnPeriodenAbhaengigeDaten.HeightPercent := 100.00000000000000000;
    btnPeriodenAbhaengigeDaten.WidthPercent := 100.00000000000000000;
    SetEvent(btnPeriodenAbhaengigeDaten, Self, 'OnClick', 'btnPeriodenAbhaengigeDatenClick');
    pnBerechnung.SetParentComponent(Self);
    pnBerechnung.Name := 'pnBerechnung';
    pnBerechnung.Left := 128;
    pnBerechnung.Top := 588;
    pnBerechnung.Width := 545;
    pnBerechnung.Height := 385;
    pnBerechnung.ChildOrder := 2;
    pnBerechnung.ElementFont := efCSS;
    pnBerechnung.Enabled := False;
    pnBerechnung.TabOrder := 4;
    WebLabel10.SetParentComponent(pnBerechnung);
    WebLabel10.Name := 'WebLabel10';
    WebLabel10.Left := 24;
    WebLabel10.Top := 48;
    WebLabel10.Width := 77;
    WebLabel10.Height := 18;
    WebLabel10.Caption := 'Berechnung';
    WebLabel10.ElementFont := efCSS;
    WebLabel10.HeightStyle := ssAuto;
    WebLabel10.HeightPercent := 100.00000000000000000;
    WebLabel10.HTMLType := tH2;
    WebLabel10.WidthPercent := 100.00000000000000000;
    WebLabel11.SetParentComponent(pnBerechnung);
    WebLabel11.Name := 'WebLabel11';
    WebLabel11.Left := 24;
    WebLabel11.Top := 88;
    WebLabel11.Width := 281;
    WebLabel11.Height := 18;
    WebLabel11.Caption := 'Hier k'#246'nnen Sie Berechnungen durchf'#252'hren';
    WebLabel11.ElementFont := efCSS;
    WebLabel11.HeightStyle := ssAuto;
    WebLabel11.HeightPercent := 100.00000000000000000;
    WebLabel11.HTMLType := tP;
    WebLabel11.WidthPercent := 100.00000000000000000;
    WebLabel12.SetParentComponent(pnBerechnung);
    WebLabel12.Name := 'WebLabel12';
    WebLabel12.Left := 24;
    WebLabel12.Top := 128;
    WebLabel12.Width := 86;
    WebLabel12.Height := 18;
    WebLabel12.Caption := 'Quick-Actions';
    WebLabel12.ElementFont := efCSS;
    WebLabel12.HeightStyle := ssAuto;
    WebLabel12.HeightPercent := 100.00000000000000000;
    WebLabel12.HTMLType := tH3;
    WebLabel12.WidthPercent := 100.00000000000000000;
    btnCalculateActPeriod.SetParentComponent(pnBerechnung);
    btnCalculateActPeriod.Name := 'btnCalculateActPeriod';
    btnCalculateActPeriod.Left := 148;
    btnCalculateActPeriod.Top := 168;
    btnCalculateActPeriod.Width := 96;
    btnCalculateActPeriod.Height := 25;
    btnCalculateActPeriod.Caption := '<i class="bi bi-arrow-counterclockwise"></i> Berechnung wiederholen';
    btnCalculateActPeriod.ChildOrder := 1;
    btnCalculateActPeriod.ElementFont := efCSS;
    btnCalculateActPeriod.HeightStyle := ssAuto;
    btnCalculateActPeriod.HeightPercent := 100.00000000000000000;
    btnCalculateActPeriod.WidthPercent := 100.00000000000000000;
    SetEvent(btnCalculateActPeriod, Self, 'OnClick', 'btnCalculateActPeriodClick');
    btnCalculateNextPeriod.SetParentComponent(pnBerechnung);
    btnCalculateNextPeriod.Name := 'btnCalculateNextPeriod';
    btnCalculateNextPeriod.Left := 24;
    btnCalculateNextPeriod.Top := 168;
    btnCalculateNextPeriod.Width := 96;
    btnCalculateNextPeriod.Height := 25;
    btnCalculateNextPeriod.Caption := '<i class="bi bi-calculator"></i> Periode berechnen';
    btnCalculateNextPeriod.ChildOrder := 2;
    btnCalculateNextPeriod.ElementFont := efCSS;
    btnCalculateNextPeriod.HeightStyle := ssAuto;
    btnCalculateNextPeriod.HeightPercent := 100.00000000000000000;
    btnCalculateNextPeriod.WidthPercent := 100.00000000000000000;
    SetEvent(btnCalculateNextPeriod, Self, 'OnClick', 'btnCalculateNextPeriodClick');
    pnBerichte.SetParentComponent(Self);
    pnBerichte.Name := 'pnBerichte';
    pnBerichte.Left := 768;
    pnBerichte.Top := 588;
    pnBerichte.Width := 545;
    pnBerichte.Height := 385;
    pnBerichte.ChildOrder := 2;
    pnBerichte.ElementFont := efCSS;
    pnBerichte.Enabled := False;
    pnBerichte.TabOrder := 5;
    WebLabel13.SetParentComponent(pnBerichte);
    WebLabel13.Name := 'WebLabel13';
    WebLabel13.Left := 48;
    WebLabel13.Top := 40;
    WebLabel13.Width := 52;
    WebLabel13.Height := 18;
    WebLabel13.Caption := 'Berichte';
    WebLabel13.ElementFont := efCSS;
    WebLabel13.HeightStyle := ssAuto;
    WebLabel13.HeightPercent := 100.00000000000000000;
    WebLabel13.HTMLType := tH2;
    WebLabel13.WidthPercent := 100.00000000000000000;
    WebLabel14.SetParentComponent(pnBerichte);
    WebLabel14.Name := 'WebLabel14';
    WebLabel14.Left := 44;
    WebLabel14.Top := 80;
    WebLabel14.Width := 242;
    WebLabel14.Height := 18;
    WebLabel14.Caption := 'Hier k'#246'nnen Sie die Berichte einsehen';
    WebLabel14.ElementFont := efCSS;
    WebLabel14.HeightStyle := ssAuto;
    WebLabel14.HeightPercent := 100.00000000000000000;
    WebLabel14.HTMLType := tP;
    WebLabel14.WidthPercent := 100.00000000000000000;
    WebLabel15.SetParentComponent(pnBerichte);
    WebLabel15.Name := 'WebLabel15';
    WebLabel15.Left := 48;
    WebLabel15.Top := 241;
    WebLabel15.Width := 50;
    WebLabel15.Height := 18;
    WebLabel15.Caption := 'Eingabe';
    WebLabel15.ElementFont := efCSS;
    WebLabel15.HeightStyle := ssAuto;
    WebLabel15.HeightPercent := 100.00000000000000000;
    WebLabel15.HTMLType := tH3;
    WebLabel15.WidthPercent := 100.00000000000000000;
    btnTLNReportPrint.SetParentComponent(pnBerichte);
    btnTLNReportPrint.Name := 'btnTLNReportPrint';
    btnTLNReportPrint.Left := 48;
    btnTLNReportPrint.Top := 295;
    btnTLNReportPrint.Width := 96;
    btnTLNReportPrint.Height := 25;
    btnTLNReportPrint.Caption := 'Teilnehmendenberichte';
    btnTLNReportPrint.ChildOrder := 5;
    btnTLNReportPrint.ElementFont := efCSS;
    btnTLNReportPrint.HeightStyle := ssAuto;
    btnTLNReportPrint.HeightPercent := 100.00000000000000000;
    btnTLNReportPrint.WidthPercent := 100.00000000000000000;
    SetEvent(btnTLNReportPrint, Self, 'OnClick', 'btnTLNReportPrintClick');
    btnSPLReportPrint.SetParentComponent(pnBerichte);
    btnSPLReportPrint.Name := 'btnSPLReportPrint';
    btnSPLReportPrint.Left := 200;
    btnSPLReportPrint.Top := 296;
    btnSPLReportPrint.Width := 96;
    btnSPLReportPrint.Height := 25;
    btnSPLReportPrint.Caption := 'Spielleitendenberichte';
    btnSPLReportPrint.ChildOrder := 6;
    btnSPLReportPrint.ElementFont := efCSS;
    btnSPLReportPrint.HeightStyle := ssAuto;
    btnSPLReportPrint.HeightPercent := 100.00000000000000000;
    btnSPLReportPrint.WidthPercent := 100.00000000000000000;
    SetEvent(btnSPLReportPrint, Self, 'OnClick', 'btnSPLReportPrintClick');
    WebMessageDlg.SetParentComponent(Self);
    WebMessageDlg.Name := 'WebMessageDlg';
    WebMessageDlg.Left := 56;
    WebMessageDlg.Top := 129;
    WebMessageDlg.Width := 24;
    WebMessageDlg.Height := 24;
    WebMessageDlg.Buttons := [];
    WebMessageDlg.Opacity := 0.20000000000000000;
    WebMessageDlg.ElementButtonClassName := 'btn';
    WebMessageDlg.ElementDialogClassName := 'shadow-lg p-3 mb-5 bg-white rounded';
    WebMessageDlg.ElementTitleClassName := 'text-body';
    WebMessageDlg.ElementContentClassName := 'text-body';
    XDataWebConnectionMain.SetParentComponent(Self);
    XDataWebConnectionMain.Name := 'XDataWebConnectionMain';
    XDataWebConnectionMain.URL := 'https://hbm-online.eu/MFCWebServices/';
    SetEvent(XDataWebConnectionMain, Self, 'OnConnect', 'XDataWebConnectionMainConnect');
    SetEvent(XDataWebConnectionMain, Self, 'OnError', 'XDataWebConnectionMainError');
    XDataWebConnectionMain.Left := 152;
    XDataWebConnectionMain.Top := 120;
    XDataWebDataSetModul.SetParentComponent(Self);
    XDataWebDataSetModul.Name := 'XDataWebDataSetModul';
    XDataWebDataSetModul.AfterOpen := XDataWebDataSetModulAfterOpen;
    XDataWebDataSetModul.EntitySetName := 'Tblhbm_Inperiodic_Modul_Data';
    XDataWebDataSetModul.Connection := XDataWebConnectionMain;
    XDataWebDataSetModul.Left := 332;
    XDataWebDataSetModul.Top := 120;
  finally
    WaitMessage.AfterLoadDFMValues;
    pnNavBar.AfterLoadDFMValues;
    btnLogout.AfterLoadDFMValues;
    pnSimulation.AfterLoadDFMValues;
    WebLabel5.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    btnResetSimulation.AfterLoadDFMValues;
    btnRestePassword.AfterLoadDFMValues;
    btnSeminarKennDaten.AfterLoadDFMValues;
    btnAusgangsLoesung.AfterLoadDFMValues;
    btnPeriodenUnabhaengigeDaten.AfterLoadDFMValues;
    btnWirkungskurven.AfterLoadDFMValues;
    pnEntscheidungsdaten.AfterLoadDFMValues;
    WebLabel6.AfterLoadDFMValues;
    WebLabel7.AfterLoadDFMValues;
    WebLabel8.AfterLoadDFMValues;
    WebLabel9.AfterLoadDFMValues;
    btnQuickZweckMittel.AfterLoadDFMValues;
    btnQuickMVZ.AfterLoadDFMValues;
    btnEntscheidungsdaten.AfterLoadDFMValues;
    btnPeriodenAbhaengigeDaten.AfterLoadDFMValues;
    pnBerechnung.AfterLoadDFMValues;
    WebLabel10.AfterLoadDFMValues;
    WebLabel11.AfterLoadDFMValues;
    WebLabel12.AfterLoadDFMValues;
    btnCalculateActPeriod.AfterLoadDFMValues;
    btnCalculateNextPeriod.AfterLoadDFMValues;
    pnBerichte.AfterLoadDFMValues;
    WebLabel13.AfterLoadDFMValues;
    WebLabel14.AfterLoadDFMValues;
    WebLabel15.AfterLoadDFMValues;
    btnTLNReportPrint.AfterLoadDFMValues;
    btnSPLReportPrint.AfterLoadDFMValues;
    WebMessageDlg.AfterLoadDFMValues;
    XDataWebConnectionMain.AfterLoadDFMValues;
    XDataWebDataSetModul.AfterLoadDFMValues;
  end;
end;

end.
